import React, { ComponentProps } from 'react';
import { Label } from 'src/components/atomsLegacy';
import { MandatoryFieldLabel } from 'src/components/atomsLegacy/MandatoryFieldLabel/MandatoryFieldLabel';
import styled from 'styled-components';

type Props = ComponentProps<typeof TextArea> & {
  label?: string;
  required?: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => Promise<unknown> | void;
};

export const EventTextArea = ({ label, required, ...props }: Props) => (
  <Container>
    {label &&
      (required ? (
        <MandatoryFieldLabel>
          <Label htmlFor={props.id}>{label}</Label>
        </MandatoryFieldLabel>
      ) : (
        <Label htmlFor={props.id}>{label}</Label>
      ))}
    <TextArea {...props} />
  </Container>
);

const Container = styled.div`
  margin-top: 24px;
`;

const TextArea = styled.textarea`
  border: solid 1px
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  border-radius: 4px;
  width: 100%;
  margin-top: 16px;
  font-family: ${(props) => props.theme.typography.fontFamily};
`;
